import { render, staticRenderFns } from "./ResearchPaid.pug?vue&type=template&id=d44f4634&external"
import script from "./ResearchPaid.js?vue&type=script&lang=js&external"
export * from "./ResearchPaid.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports